import { render, staticRenderFns } from "./CalculationList.vue?vue&type=template&id=ca0fb224&scoped=true&"
import script from "./CalculationList.vue?vue&type=script&lang=js&"
export * from "./CalculationList.vue?vue&type=script&lang=js&"
import style0 from "./CalculationList.vue?vue&type=style&index=0&id=ca0fb224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0fb224",
  null
  
)

export default component.exports